"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_i18next_1 = require("react-i18next");
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var BaseLayout_1 = __importDefault(require("../app/components/BaseLayout"));
var minifiedActions_1 = __importDefault(require("../user/components/CreateUrlModal/helpers/minifiedActions"));
var AppMargins_1 = require("../app/components/AppMargins");
var en_1 = require("./contents/en");
var kh_1 = require("./contents/kh");
var useStyles = core_1.makeStyles(function (theme) {
    var _a, _b;
    return core_1.createStyles({
        privacyHeader: (_a = {
                flexGrow: 1,
                flexShrink: 0,
                marginRight: 20,
                marginTop: theme.spacing(4),
                whiteSpace: 'nowrap',
                textAlign: 'center'
            },
            _a[theme.breakpoints.down('sm')] = {
                order: 10,
                flexBasis: '100%',
                marginTop: theme.spacing(3),
            },
            _a),
        privacyContent: (_b = {
                fontSize: 16,
                padding: theme.spacing(3) + "px " + theme.spacing(22) + "px"
            },
            _b[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(3),
            },
            _b),
    });
});
/**
 * Show the privacy and policy page.
 */
var PrivacyPage = function () {
    var _a = __read(react_i18next_1.useTranslation(), 2), t = _a[0], i18n = _a[1];
    var _b = __read(react_1.useState(kh_1.kmContent), 2), html = _b[0], setHtml = _b[1];
    var isMinified = minifiedActions_1.default();
    var classes = useStyles();
    react_1.useEffect(function () {
        var rawHTML = i18n.language === 'km' ? kh_1.kmContent : en_1.enContent;
        setHtml(rawHTML);
    }, [i18n.language]);
    return (react_1.default.createElement(BaseLayout_1.default, { layoutStyle: { backgroundColor: 'white' } },
        react_1.default.createElement(AppMargins_1.ApplyAppMargins, null,
            react_1.default.createElement(core_1.Typography, { className: classes.privacyHeader, variant: isMinified ? 'h3' : 'h2', color: "primary" }, t('privacy.title')),
            react_1.default.createElement(core_1.Grid, { container: true, direction: "column", justifyContent: "center", alignItems: "center" },
                react_1.default.createElement("div", { className: classes.privacyContent, dangerouslySetInnerHTML: { __html: html } })))));
};
exports.default = PrivacyPage;
